import { isPlainObject } from "lodash-es";

// Hash an object to a string with key-order-insensitive equality. This is a
// workaround to avoid using isEqual from lodash, which might return false
// even when two objects "look" the same.
export const hashObject = (object: unknown): string => {
  return JSON.stringify(object, (_, val) =>
    isPlainObject(val)
      ? Object.keys(val)
          .sort()
          .reduce(
            (result, key) => {
              result[key] = val[key];
              return result;
            },
            {} as Record<string, unknown>,
          )
      : val,
  );
};
